import React, { useState } from 'react';
import axios from 'axios';
import Env from '../../runtimeEnv';

const AdminResendPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState(null); 
//   const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    // setError('');
  
    try {
      const response = await axios.post(`${Env.REACT_APP_PYTHON_API_URL}/api/forgot-password`, {
        email,
      });
  
      console.log("✅ Response:", response.data);
      setMessage({ type: "success", text: "email resent successfully!" });

    } catch (error) {
      console.error("❌ Error:", error.response?.data || error.message);
      setMessage({
        type: "error",
        text: error.response?.data?.message || "Failed to resend email.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 max-w-md mx-auto bg-white shadow-md rounded">
      {/* <h2 className="text-xl font-semibold mb-4">Resend Temporary Password</h2> */}
      <form onSubmit={handleSubmit}>
        <label className="block mb-2">
          Email:
          <input
            type="email"
            value={email}
            required
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded mt-1"
          />
        </label>
        {/* <button
          type="submit"
          className="mt-4 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          disabled={loading}
        >
          {loading ? 'Sending...' : 'Send Temporary Password'}
        </button> */}
         <button type="submit" className="button-primary" disabled={loading}>
        {loading ? "Sending Email..." : "Send Reset Email"}
      </button>
      </form>
      {message?.text && (
        <p
          className={`mt-4 ${message.type === 'success' ? 'text-green-600' : 'text-red-600'}`}
        >
          {message.text}
        </p>
      )}
    </div>
  );
};

export default AdminResendPassword;
